import * as angular from "angular";
import { NationBuilderDataProvider } from "../../data-provider/nation-builder.dp";
import { PermissionCheck } from "../../shared/permission";
import { SurveyService } from "../../services/survey.service";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { SurveyDataProvider } from "../../data-provider/survey.dp";
import { SearchUtils } from "../../helper/search.helper";
import { Utils } from "../../helper/utils.helper";
import { Organisation } from "../../models/organisation.model";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";

let SurveyList = {
    selector: "vcSurveyList",
    templateUrl: "/angular/components/survey/survey-list.component.html",
    bindings: {},
    controller: class SurveyListController {
        public surveys: any[] = [];
        public loading = true;
        public search = "";
        public isLeaderView: boolean;
        public description: string;
        public nation: any;
        public showNationbuilderButton = false;
        public loadingNations = false;
        public importing = false;

        private $scope: any;
        private toast: ToastUtils;
        private dialog: DialogUtils;
        private $q: any;
        private $window: any;
        public __env: any;

        private service: SurveyService;
        private dataProvider: SurveyDataProvider;
        public permissionProvider: PermissionCheck;
        public campaignDataProvider: CampaignDataProvider;

        constructor(
            $scope: any,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils,
            $q: any,
            $window: any,
            __env: any,
            __app_type: string,
            SurveyService: SurveyService,
            SurveyDataProvider: SurveyDataProvider,
            NationBuilderDataProvider: NationBuilderDataProvider,
            SearchUtils: SearchUtils,
            Utils: Utils,
            PermissionCheck: PermissionCheck,
            CampaignDataProvider: CampaignDataProvider
        ) {
            this.$scope = $scope;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;
            this.$q = $q;
            this.$window = $window;
            this.__env = __env;

            this.service = SurveyService;
            this.dataProvider = SurveyDataProvider;
            this.permissionProvider = PermissionCheck;
            this.campaignDataProvider = CampaignDataProvider;

            Utils.accessCheck();
            Utils.runWootric();
            this.isLeaderView = __app_type == "LEADER";
            this.description = this.isLeaderView
                ? "The survey builder for all your " +
                  this.__env.strings.campaign +
                  "s"
                : "Tailor your questions to get the answers you need";

            this.permissionProvider.getFeaturePermissions().then();
            {
                if (!this.isLeaderView) {
                    this.loadingNations = true;
                    NationBuilderDataProvider.getNations().then(
                        (jsonData: any) => {
                            if (jsonData.length > 0) {
                                this.nation = jsonData[0];
                                if (this.nation.nbaccesstoken) {
                                    this.showNationbuilderButton = true;
                                }
                            }
                            this.loadingNations = false;
                        },
                        () => (this.loadingNations = false)
                    );
                } else {
                    CampaignDataProvider.getOrganisations().then(
                        (organisation: Organisation) => {
                            if (
                                organisation.oid == 646 ||
                                organisation.oid == 1
                            ) {
                                this.showNationbuilderButton = true;
                            }
                        }
                    );
                }

                SearchUtils.setSearchBar(
                    "Search Surveys",
                    (searchText: string): any => {
                        this.search = searchText;
                        return this.$q.resolve([]); //Not using the results for the search dropdown so return empty.
                    }
                );

                this.loadSurveys();
            }
        }

        updateSurvey(survey: any, teamOnly: any, ev: any): void {
            this.dialog
                .show({
                    component: "vc-survey-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        selectedSurvey: survey,
                        teamOnly: teamOnly,
                    },
                })
                .then((returnedSurvey: any) => {
                    this.toast.success("Survey updated");
                    survey.team = null;
                    angular.extend(survey, returnedSurvey);
                });
        }

        exportSurvey(survey: any, ev: any): void {
            this.openExportSurvey(survey, ev);
        }

        openExportSurvey(survey: any, ev: any): void {
            if (!this.isLeaderView) {
                this.dialog.show({
                    component: "vc-result-export-dialog",
                    size: "large",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        survey: survey.sid,
                    },
                });
            } else {
                this.dialog.show({
                    component: "vc-organisation-result-export",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        survey: survey.sid,
                    },
                    size: "large",
                    ariaLabel: "Export Data",
                });
            }
        }

        deleteSurvey(survey: any, ev: any): void {
            let leaderString = "";
            if (this.isLeaderView) {
                leaderString =
                    "<p  class='layout-margin no-side-margin'>" +
                    "This will be deleted across all <span class='bold no-margin'>" +
                    this.campaignDataProvider.activeOrganisation.campaigns
                        .length +
                    " campaigns</span> in your organization account.</p>";
            }
            this.dialog
                .delete({
                    targetEvent: ev,
                    skipHide: true,
                    fullscreen: true,
                    locals: {
                        title: `Delete Survey?`,
                        bodyText:
                            "<p  class='layout-margin no-side-margin'>You are about to permanently delete this survey, its questions, responses and all associated data.</p>" +
                            leaderString +
                            "<p  class='layout-margin no-side-margin'>Click confirm if you are certain that you wish to proceed.</p>",
                    },
                })
                .then(() => {
                    this.service.delete(survey.sid).then((response: object) => {
                        const json = response["data"];
                        if (json.success) {
                            this.dataProvider.clearAll();
                            if (this.isLeaderView) {
                                this.$window.location =
                                    "./leader.php#/leader_survey/";
                            } else {
                                this.$window.location = "./#/survey/";
                            }
                        } else {
                            this.toast.error();
                        }
                    });
                });
        }

        toggleSignature(survey: any): void {
            survey.signature = survey.signature == "0" ? "1" : "0";
            this.dataProvider.update(survey);
        }

        openErrorDialog(string: string, ev?: any): void {
            const content =
                string == "publish"
                    ? "Sorry but you need at least 1 question to publish a survey"
                    : "This survey was published at organization level so cannot be altered at the account level";

            let dialog = this.dialog
                .alert()
                .textContent(content)
                .targetEvent(ev)
                .ok("OK");
            this.dialog.showPreConfiguredDialog(dialog);
        }

        loadSurveys(): void {
            this.dataProvider.getAllSurveys().then((surveys: any[]) => {
                this.loading = false;
                this.surveys = surveys;
            });
        }

        goToSurvey(survey: any): void {
            if (this.isLeaderView) {
                this.$window.location =
                    "./leader.php#/leader_survey/" + survey.sid;
            } else {
                this.$window.location = "./#/survey/" + survey.sid;
            }
        }

        getViewSurveyURL(survey: any): string {
            if (this.isLeaderView) {
                return "./leader.php#/leader_survey/" + survey.sid;
            } else {
                return "./#/survey/" + survey.sid;
            }
        }

        toggleStatus(survey: any): void {
            if (survey.question_count <= 0 || survey.osid) {
                if (survey.osid) {
                    this.openErrorDialog("leader");
                } else {
                    this.openErrorDialog("publish");
                }
            } else {
                if (!survey.disabled || survey.disabled == "0") {
                    survey.sstatus =
                        survey.sstatus == "Live" ? "Not Live" : "Live";

                    this.service.update(survey).then((response: object) => {
                        const json = response["data"];
                        if (json.success) {
                            this.dataProvider.clearSurveyLists();
                            angular.extend(survey, json.data);
                        }
                    });
                }
            }
        }

        createSurveyDialog(ev: any): void {
            this.dialog
                .show({
                    component: "vc-survey-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        selectedSurvey: {},
                        teamOnly: false,
                    },
                })
                .then((survey: any) => {
                    this.goToSurvey(survey);
                });
        }

        importNationBuilder($event: any): void {
            this.importing = true;
            this.service.importNationBuilder({}).then((response: object) => {
                const json = response["data"];
                this.importing = false;
                if (json.success) {
                    if (!this.isLeaderView) {
                        this.toast.success("NationBuilder surveys imported");
                    } else {
                        this.toast.success(
                            "NationBuilder survey importing has begun. Your surveys should appear in time on each individual account.",
                            10000
                        );
                    }
                } else {
                    this.toast.error("NationBuilder request limit reached");
                }

                if (!this.isLeaderView) {
                    this.loadSurveys();
                }
            });
        }
    },
};

angular.module("survey").component(SurveyList.selector, SurveyList);
